import { render, staticRenderFns } from "./housingPoint.vue?vue&type=template&id=6c3eb588&scoped=true"
import script from "./housingPoint.vue?vue&type=script&lang=js"
export * from "./housingPoint.vue?vue&type=script&lang=js"
import style0 from "./housingPoint.vue?vue&type=style&index=0&id=6c3eb588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3eb588",
  null
  
)

export default component.exports